module.exports = "<div class=\"time early\"><span>07:00</span></div> <div class=\"time mid\"><span>15:00</span></div> <div class=\"time late\"><span>23:00</span></div> <h4 class=van title=\"Van {{vm.id}} ( {{ vm.data.type }} )\"> Van {{ vm.id }} <br/> <span ng-if=\"vm.data.type != 'HD'\"> ( {{ vm.data.type }} )</span> </h4> <div class=day ng-repeat=\"day in vm.shifts\"> <day shifts=day.shifts date=day.shiftDate driver-holiday=day.driverHoliday></day> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/planner/week/template.html
// module id = 213
// module chunks = 0